import { Breadcrumbs as ToolkitBreadcrumbs } from '@ox-technologies/ui';
import { useLocation, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { appRoutes } from 'utils/routing/routes';

type Breadcrumb = {
  label: string;
  href: string;
};

const Breadcrumbs = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const dashboard: Breadcrumb = {
    label: t('Breadcrumbs.Dashboard'),
    href: appRoutes.dashboard,
  };

  let breadcrumbs: Breadcrumb[];
  switch (location.pathname) {
    case appRoutes.changePassword:
      breadcrumbs = [
        dashboard,
        {
          label: t('Breadcrumbs.ChangePassword'),
          href: appRoutes.changePassword,
        },
      ];
      break;
    case appRoutes.deviceCode:
      breadcrumbs = [
        dashboard,
        {
          label: t('Breadcrumbs.DeviceCode'),
          href: appRoutes.deviceCode,
        },
      ];
      break;
    case appRoutes.profile:
      breadcrumbs = [
        dashboard,
        {
          label: t('Breadcrumbs.Profile'),
          href: appRoutes.profile,
        },
      ];
      break;
    default:
      breadcrumbs = [dashboard];
      break;
  }

  // The toolkit Breadcrumbs renders plain anchors; intercept clicks so
  // navigation stays client-side (router) instead of a full reload.
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const anchor = (event.target as HTMLElement).closest('a');
    if (!anchor) {
      return;
    }
    // Leave ctrl/cmd/shift-click (and anything but the primary button) to the
    // browser so "open in new tab/window" keeps working on breadcrumb links.
    if (
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0
    ) {
      return;
    }
    event.preventDefault();
    navigate({ to: anchor.getAttribute('href') ?? appRoutes.dashboard });
  };

  return (
    <div onClick={handleClick}>
      <ToolkitBreadcrumbs items={breadcrumbs} />
    </div>
  );
};

export default Breadcrumbs;
